import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';

export default class GoalsTableInitiativesSelectorComponent extends DropdownActivator {
  @service store;
  @tracked initiativeFormIsVisible = false;
  selectedGoal = null;

  get goal() {
    return this.args.goal;
  }

  @action
  handleInitiativesChange(goal, e) {
    const initiatives = e.map((id) => this.store.peekRecord('initiative', id));
    goal.initiatives = initiatives;
    goal.save();
  }

  @action
  toggleGoalForm(initiative, val) {
    if (initiative) this.selectedGoal = initiative;
    else this.selectedGoal = null;
    if (val !== undefined) this.initiativeFormIsVisible = val;
    else this.initiativeFormIsVisible = !this.initiativeFormIsVisible;
  }

  @action
  async onGoalAdded(goal) {
    const goals = [...this.selectedGoal.goals.content];
    goals.push(goal);
    this.selectedGoal.goals = goals;
    await this.selectedGoal.save();
  }

  get initiativesList() {
    const initiatives = this.store.peekAll('initiative').map((item) => ({
      value: item.id,
      label: item.title,
    }));
    return initiatives;
  }
}
